<template>
  <div>
    <div class="contain">
      <Progress progress="58"></Progress>
      <van-notice-bar
        class="read-notice"
        color="#ed6a0c"
        background="#fffbe8"
        left-icon="warning-o"
        :scrollable="false"
        wrapable
        :text="$t('exemptedCustomers.readTip')"
      />
      <div class="part-6">
        <div class="content">
          <div class="main-text">
            <div
              v-for="(item,index) in textContent"
              :key="item.title"
              class="text-item"
            >
              <p class="item-title">{{ item.title }}</p>
              <p v-for="(child, i) in item.content" :key="i" class="item-text">
                <span>{{ child.num }}</span>
                <span :class="{'textIndent':index == 0}">{{ child.text }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom-box">
        <div class="next-btn" @click="handNext">
          {{  $route.query.change == 1 ? $t('openAccount.t000094') : $t('exemptedCustomers.lang') }}
        </div>
        <div class="not-dom" @click="$router.push('/open-account/riskQuestionnaire')">
          <span>{{ $t('exemptedCustomers.lang0') }}</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import Progress from "../components/Progress.vue";
import { Toast, NoticeBar } from "vant";

export default {
  components: {
    Progress,
    [NoticeBar.name]: NoticeBar
  },
  data() {
    return {
      textContent: this.$t("exemptedCustomers.textContent"),
      process_id: ""
    };
  },
  created() {
    this.handDetail();
  },
  methods: {
    handDetail() {
      const params = {
        step_code:'1'
      }
      this.$apis.accountSituationV2(params).then(res => {
        if (res.process_info) {
          this.process_id = res?.process_info["1"]?.process_id;
        }
      });
    },
    handNext() {
      const params = {
        process_id: this.process_id,
        step_code: "8-3",
        step_order: 8,
        config_data: {}
      };
      const toastLoading = Toast.loading({
        duration: 0,
        forbidClick: true,
        loadingType: "spinner",
        message: this.$t("common.loading_text")
      });
      this.$apis
        .supplementSaveApi(params)
        .then((res) => {
          if (res) {
            let path = "/open-account/taxInformation";
            if(this.$route.query.change == 1){
              path = "/open-account/home"
            }
            this.$router.push({
              path
            }).finally(() => {
              toastLoading.clear();
            });
          }
        });
    }
  }
};
</script>

<style lang="less" scoped>
.contain {
  margin-top: 60px;

  .read-notice {
    margin: 0;
    padding: 16px 30px;
    border-radius: 0;
    font-size: 26px;
    line-height: 36px;
  }

  .part-6 {
    padding: 30px;

    .content {
     margin-bottom: 230px;
      .tip {
        font-size: 32px;
        font-weight: 500;
        color: #17161C;
        width: 100%;
        line-height: 2;
      }

      .main-text {
        margin-top: 20px;

        .item-title {
          font-size: 36px;
          font-weight: 500;
          color: #000000;
          width: 100%;
          line-height: 48px;
          text-align: center;
        }

        .item-text {
          line-height: 1.5;
          font-size: 28px;
          color: #17161C;
          font-weight: 400;
          margin-top: 40px;
          margin-bottom: 44px;
        }
        .textIndent{
          text-indent: 2em;
          display: inline-block;
          margin-top: -49px;
          line-height: 1.6;
        }
      }
    }
  }
}
.bottom-box{
  width: 100%;
  text-align: center;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  box-sizing: border-box;
  z-index: 100;
  padding: 30px 0px 10px;
  .next-btn{
    text-align: center;
    flex: 1;
    height: 104px;
    line-height: 104px;
    background: #17161C;
    border-radius: 200px;
    font-size: 32px;
    background: #17161c;
    color: #FFFFFF;
    margin-left: 88px;
    margin-right: 88px;
    font-weight: 500;
  }
  .not-dom{
    font-size: 28px;
    color: #747377;
    margin-top: 30px;
    margin-bottom: 30px;
  }
}
.black-theme{
  .contain{
    .read-notice {
      color: #ff976a !important;
      background: rgba(237, 106, 12, 0.16) !important;
    }
    .part-6{
      .main-text{
        color: #FFFFFF;
        .item-title{
          color: #FFFFFF;
        }
        .item-text{
          color: #FFFFFF;
        }
      }
    }
    .bottom-box{
      background: #1B1C24;
      .next-btn{
        background: #377CFB;
      }
      .not-dom{
        color: #FFFFFF;
      }
    }
  }
}

</style>
